import axios from "axios";

export default class axiosClient {
  async getPlatforms(params) {
    const headers = {
      accept: "application/ld+json",
      "Content-Type": "application/ld+json"
    };
    const resp = await axios.get("/api/external_platforms", { headers, params });
    const data = resp.data["hydra:member"];
    const totalItems = resp.data["hydra:totalItems"];
    return { data, totalItems };
  }
  async getPlatformById(id) {
    return await axios.get(`/api/external_platforms/${id}`);
  }
  async createPlatform(params) {
    return await axios.post("/api/external_platforms", params);
  }
  async editPlatform(params) {
    const headers = {
      "Content-Type": "application/merge-patch+json"
    };
    return await axios.patch(`/api/external_platforms/${params.id}`, params, { headers });
  }
  async deletePlatform(id) {
    return await axios.delete(`/api/external_platforms/${id}`);
  }

  async freezePlatform(id) {
    return await axios.get(`/api/external_platforms/freeze/${id}`);
  }

  async verifyPlatform(id) {
    return await axios.get(`/api/external_platforms/verify_domain/${id}`);
  }

  async getPlatformKey(id) {
    return await axios.get(`/api/external_platforms/get_platform_key/${id}`);
  }
  async getPlatformDocs() {
    return await axios.get("/api/external_platforms/get_platform_routes");
  }

}